export default "__VITE_ASSET__DWwk3hp5__"